import {
	CreateMediaRoomRequest,
	CreateMediaRoomResponse,
	GetActiveMediaRoomsResponse,
	IssueJoinTokenRequest,
	IssueJoinTokenResponse,
} from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const mediaCommRoomActions = {
	createMediaRoom: createActionSet<
		CreateMediaRoomRequest.AsObject,
		CreateMediaRoomResponse.AsObject
	>("mediaComms/createMediaRoom/create"),
	getActiveMediaRooms: createActionSet<void, GetActiveMediaRoomsResponse.AsObject>(
		"mediaComms/getActiveMediaRooms/get",
	),
	getMediaRoomJoinToken: createActionSet<
		IssueJoinTokenRequest.AsObject,
		IssueJoinTokenResponse.AsObject
	>("mediaComms/getJoinToken/get"),
};
